import { Link } from '@tanstack/react-router';
import React from 'react';
import AttentionIcon from './-assets/icon_attention.svg';
import styles from './index.module.scss';

export type ImportantNotificationBlockProps = {
  dateStr: string;
  description: string;
  url?: string | null;
};

export const ImportantNotificationBlock = ({
  dateStr,
  description,
  url,
}: ImportantNotificationBlockProps) => {
  return (
    <div className={styles.notificationBlock}>
      <p className={styles.notificationTitle}>
        <img
          className={styles.notificationTitle_iconImg}
          src={AttentionIcon}
          alt=""
        />
        <span className={styles.notificationTitle_label}>重要</span>
        <span className={styles.notificationTitle_date}>{dateStr}</span>
      </p>
      <div className={styles.messageBlock}>
        <p className={styles.messageBlock_text}>{description}</p>
        {url && (
          <div className={styles.messageBlock_linkWrap}>
            <Link
              to={url}
              target="_blank"
              className={styles.messageBlock_linkWrap_link}
            >
              詳細はこちら
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
